__turbopack_context__.v({
  "bottom": "embla-module-scss-module__TBqDuG__bottom",
  "carouselThreeD": "embla-module-scss-module__TBqDuG__carouselThreeD",
  "contentflex": "embla-module-scss-module__TBqDuG__contentflex",
  "embla": "embla-module-scss-module__TBqDuG__embla",
  "embla__button": "embla-module-scss-module__TBqDuG__embla__button",
  "embla__button__svg": "embla-module-scss-module__TBqDuG__embla__button__svg",
  "embla__button_next": "embla-module-scss-module__TBqDuG__embla__button_next",
  "embla__button_prev": "embla-module-scss-module__TBqDuG__embla__button_prev",
  "embla__container": "embla-module-scss-module__TBqDuG__embla__container",
  "embla__controls": "embla-module-scss-module__TBqDuG__embla__controls",
  "embla__dot": "embla-module-scss-module__TBqDuG__embla__dot",
  "embla__dot__selected": "embla-module-scss-module__TBqDuG__embla__dot__selected",
  "embla__dots": "embla-module-scss-module__TBqDuG__embla__dots",
  "embla__slide": "embla-module-scss-module__TBqDuG__embla__slide",
  "embla__slide__img": "embla-module-scss-module__TBqDuG__embla__slide__img",
  "embla__viewport": "embla-module-scss-module__TBqDuG__embla__viewport",
  "none": "embla-module-scss-module__TBqDuG__none",
  "singlebottom": "embla-module-scss-module__TBqDuG__singlebottom",
  "top": "embla-module-scss-module__TBqDuG__top",
});
